import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminProtectedRoute from "@/components/AdminProtectedRoute";
import FeedbackLayer from "@/components/FeedbackLayer";
import LoginPage from "@/pages/Login";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import ResetPasswordPage from "@/pages/ResetPassword";
import AcceptInvitePage from "@/pages/AcceptInvite";
import HomePage from "@/pages/Home";
import TodayPage from "@/pages/Today";
import DealsPage from "@/pages/Deals";
import AccountsPage from "@/pages/Accounts";
import AccountDetailPage from "@/pages/AccountDetail";
import ContactsPage from "@/pages/Contacts";
import DealDetailPage from "@/pages/DealDetail";
import LibraryPage from "@/pages/Library";
import DemosPage from "@/pages/Demos";
import ContractsPage from "@/pages/Contracts";
import ContractDetailPage from "@/pages/ContractDetail";
import DashboardPage from "@/pages/Dashboard";
import ActivityPage from "@/pages/Activity";
import SettingsPage from "@/pages/Settings";
import AdminPage from "@/pages/Admin";
import { useResolvedTheme } from "@/lib/theme";

/** Applies the chosen theme to <html> so every page (login included) follows it. */
function ThemeSync() {
  const theme = useResolvedTheme();
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", theme === "dark" ? "#04050A" : "#F6F7FC");
  }, [theme]);
  return null;
}

export default function App() {
  return (
    <>
      <ThemeSync />
      <FeedbackLayer />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/invite/:token" element={<AcceptInvitePage />} />

        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<HomePage />} />
          <Route path="/today" element={<TodayPage />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/deals/:id" element={<DealDetailPage />} />
          <Route path="/pipeline" element={<Navigate to="/deals" replace />} />
          <Route path="/list" element={<Navigate to="/deals" replace />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/accounts/:id" element={<AccountDetailPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/demos" element={<DemosPage />} />
          <Route path="/contracts" element={<ContractsPage />} />
          <Route path="/contracts/:id" element={<ContractDetailPage />} />
          <Route
            path="/dashboard"
            element={
              <AdminProtectedRoute>
                <DashboardPage />
              </AdminProtectedRoute>
            }
          />
          <Route path="/activity" element={<ActivityPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminPage />
              </AdminProtectedRoute>
            }
          />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
